module.exports = __webpack_public_path__ + "img/img_8.14de29fa.png";